import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutContainer from '@/views/Layout/LayoutContainer.vue'
import AppView from '@/views/AppView.vue'
import { routes as personnelRoutes } from './personnel'
import { routes as smsRoutes } from './sms'
import { routes as taskRoutes } from './task'
import { routes as schedule } from './schedule'
import { routes as system } from './system'
import { routes as mobile } from './mobile'
import { routes as line } from './line'
import { routes as validation } from './validation'

Vue.use(VueRouter)

const routes = [
  ...personnelRoutes,
  ...smsRoutes,
  ...taskRoutes,
  ...schedule,
  ...system,
  ...mobile,
  ...line,
  ...validation,
  {
    path: '/summary',
    name: 'SummaryIndex',
    redirect: '/summary-mobile',
    component: AppView,
    children: [
      {
        path: '/summary-mobile',
        name: 'SummaryMobile',
        component: () => import('@/views/Echarts/SummaryIndex.vue'),
        meta: {
          title: '图表统计'
        }
      }
    ]
  },
  {
    path: '/test',
    redirect: '/test/index',
    component: AppView,
    children: [
      {
        path: 'index',
        component: () => import('@/components/TestComponent.vue'),
        meta: {
          title: '测试插件'
        }
      }
    ]
  },
  {
    path: '/',
    component: LayoutContainer,
    redirect: 'workbench',
    children: [
      {
        path: 'frame',
        name: 'AppFrame',
        component: () => import('@/views/Layout/components/AppIframe.vue'),
      },
      {
        path: 'workbench',
        name: 'WorkbenchIndex',
        component: () => import('@/views/Workbench/WorkbenchIndex.vue'),
        meta: {
          title: '',
          hideBack: true,
          orgName: true
        }
      },
      {
        path: '/task/table',
        name: 'TaskTable',
        component: () => import('@/views/Task/TodoTaskList.vue'),
        meta: {
          title: '待办任务'
        }
      },
      {
        path: '/task/:id',
        name: 'TaskDetail',
        component: () => import('@/views/Task/TaskDetail.vue'),
        meta: {
          title: '任务详情'
        }
      },
      {
        path: 'contact',
        name: 'ContactIndex',
        component: () => import('@/views/Contact/ContactIndex.vue')
      },
      {
        path: 'center',
        name: 'CenterIndex',
        component: () => import('@/views/Center/CenterIndex.vue'),
        meta: {
          title: '应用中心'
        }
      },
      {
        path: '/process/add',
        name: 'ProcessAdd',
        component: () => import('@/views/Process/ProcessDetail.vue'),
        meta: {
          title: '流程注册'
        }
      },
      {
        path: '/area/list',
        name: 'AreaList',
        component: () => import('@/views/Area/AreaList.vue'),
        meta: {
          title: '区域列表'
        }
      },
      {
        path: '/unitTypes/list',
        name: 'UnitTypesList',
        component: () => import('@/views/UnitTypes/UnitTypesList.vue'),
        meta: {
          title: '单位类型列表'
        }
      },
      {
        path: '/unit/list',
        name: 'UnitList',
        component: () => import('@/views/Unit/UnitList.vue'),
        meta: {
          title: '单位列表'
        }
      },
      {
        path: '/roles/list',
        name: 'RolesList',
        component: () => import('@/views/Roles/RolesList.vue'),
        meta: {
          title: '角色列表'
        }
      },
      {
        path: '/process/:id',
        name: 'ProcessView',
        component: () => import('@/views/Process/ProcessView.vue'),
        meta: {
          title: '流程控制'
        }
      },
      {
        path: '/process-result/:id',
        name: 'ProcessResult',
        component: () => import('@/views/Process/ProcessResult.vue'),
        meta: {
          title: '流程意见'
        }
      },
      {
        path: '/summary-index',
        component: () => import('@/views/Echarts/SummaryIndex.vue'),
        meta: {
          title: '图表统计'
        }
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash',
  base: ''
})

export default router
